import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import getCurrentPath from '../selectors/routing';
import useMonitorAlerts from './hooks/useMonitorAlerts';
import useMonitorAlertsEnabled from './hooks/useMonitorAlertsEnabled';
import useMonitorAlertsPoller from './hooks/useMonitorAlertsPoller';
import { dismissAllArrivals, markAllRead } from './store';
import MonitorAlertsBanner from './components/MonitorAlertsBanner';
import MonitorAlertsToasts from './components/MonitorAlertsToasts';
import { HIDE_SIDENAV_PATH_FRAGMENTS } from '../sidenav/consts';
import { WATCHLIST_PATH } from './constants';
// The host sits outside HashRouter; read its route from Redux and portal outside the scroll box.
const MonitorAlertsHost = () => {
    const enabled = useMonitorAlertsEnabled();
    const { stopped, arrivalAlerts, unreadCount } = useMonitorAlerts();
    const pathname = useSelector(state => getCurrentPath(state).pathname);
    const hasAppShell = !!document.getElementById('topbar');
    const onWatchlist = pathname.startsWith(WATCHLIST_PATH);
    useMonitorAlertsPoller(enabled && hasAppShell && !stopped && !onWatchlist);
    useEffect(() => {
        if (!onWatchlist) return;
        if (unreadCount) markAllRead();
        else if (arrivalAlerts.length) dismissAllArrivals();
    }, [onWatchlist, unreadCount, arrivalAlerts.length]);

    if (!enabled || !hasAppShell) return null;
    const noSidenav = HIDE_SIDENAV_PATH_FRAGMENTS.some(fragment => pathname.includes(fragment)) || !!window.hideSideBar;

    return createPortal(
        <>
            {!onWatchlist && !noSidenav && <MonitorAlertsBanner />}
            {!onWatchlist && <MonitorAlertsToasts />}
        </>,
        document.body
    );
};

export default MonitorAlertsHost;
